/* ==========================================================================
   Holofoil — predictive-search.js
   Live search suggestions using Shopify's predictive search endpoint and
   the Section Rendering API (sections/predictive-search.liquid).
   Normal search keeps working without this file.
   ========================================================================== */
(function () {
  'use strict';

  function setup(container) {
    var input = container.querySelector('input[type="search"]');
    var results = container.querySelector('[data-predictive-results]');
    if (!input || !results) return;

    var debounceTimer = null;
    var activeQuery = '';

    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('autocomplete', 'off');

    function show() {
      results.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    function hide() {
      results.hidden = true;
      input.setAttribute('aria-expanded', 'false');
    }

    function search(query) {
      activeQuery = query;
      var url = window.theme.routes.predictiveSearch +
        '?q=' + encodeURIComponent(query) +
        '&resources[type]=product,collection,page' +
        '&resources[limit]=8' +
        '&section_id=predictive-search';

      fetch(url)
        .then(function (response) {
          if (!response.ok) throw new Error('Predictive search unavailable');
          return response.text();
        })
        .then(function (html) {
          if (query !== activeQuery) return; // stale response
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var fresh = parsed.querySelector('[data-predictive-content]');
          if (fresh) {
            results.innerHTML = fresh.innerHTML;
            show();
          }
        })
        .catch(function () {
          hide(); // silently fall back to normal search
        });
    }

    input.addEventListener('input', function () {
      clearTimeout(debounceTimer);
      var query = input.value.trim();
      if (query.length < 2) {
        hide();
        return;
      }
      debounceTimer = setTimeout(function () { search(query); }, 250);
    });

    input.addEventListener('focus', function () {
      if (input.value.trim().length >= 2 && results.innerHTML.trim() !== '') show();
    });

    input.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') hide();
      if (event.key === 'ArrowDown' && !results.hidden) {
        var first = results.querySelector('a');
        if (first) {
          event.preventDefault();
          first.focus();
        }
      }
    });

    results.addEventListener('keydown', function (event) {
      var links = Array.prototype.slice.call(results.querySelectorAll('a'));
      var index = links.indexOf(document.activeElement);
      if (event.key === 'ArrowDown' && index > -1 && index < links.length - 1) {
        event.preventDefault();
        links[index + 1].focus();
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        if (index > 0) links[index - 1].focus();
        else input.focus();
      } else if (event.key === 'Escape') {
        hide();
        input.focus();
      }
    });

    document.addEventListener('click', function (event) {
      if (!container.contains(event.target)) hide();
    });
  }

  function init() {
    document.querySelectorAll('[data-predictive-search]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
